import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const calendarId = route.params['calendarId'];

  if (authService.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree([calendarId, 'login'], {
    queryParams: { redirect: state.url }
  });
};


